import React from 'react';
import { Link } from 'react-router-dom';
import { useMode } from '../contexts/ModeContext';
import { Mail, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { isLabs } = useMode();
  const { t } = useTranslation();

  return (
    <footer className={`py-16 px-4 border-t ${isLabs ? 'border-blue-100 bg-gradient-to-br from-blue-50 to-purple-50' : 'border-white/5 bg-[#0a0a0f]'}`}>
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          {/* Logo - GRAND */}
          <div className="md:col-span-1">
            <img 
              src={isLabs 
                ? "/labs-logo.png"
                : "/callup-logo.png"
              }
              alt="Logo"
              className="h-24 sm:h-28 mb-4"
            />
            <p className={`text-sm ${isLabs ? 'text-gray-500' : 'text-gray-500'}`}>
              {isLabs 
                ? t('footer.description_labs')
                : t('footer.description_callup')
              }
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className={`font-bold mb-4 ${isLabs ? 'text-gray-900' : 'text-white'}`}>{t('footer.navigation')}</h4>
            <ul className="space-y-2">
              <li><Link to="/" className={`text-sm ${isLabs ? 'text-gray-600 hover:text-gray-900' : 'text-gray-400 hover:text-white'}`}>{t('footer.home')}</Link></li>
              {isLabs ? (
                <>
                  <li><a href="#services" className="text-sm text-gray-600 hover:text-gray-900">{t('header.services')}</a></li>
                  <li><a href="#contact" className="text-sm text-gray-600 hover:text-gray-900">{t('footer.contact')}</a></li>
                </>
              ) : (
                <>
                  <li><a href="#pricing" className="text-sm text-gray-400 hover:text-white">{t('header.pricing')}</a></li>
                  <li><a href="#faq" className="text-sm text-gray-400 hover:text-white">{t('header.faq')}</a></li>
                </>
              )}
              <li><Link to="/login" className={`text-sm ${isLabs ? 'text-gray-600 hover:text-gray-900' : 'text-gray-400 hover:text-white'}`}>{t('footer.client_space')}</Link></li>
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h4 className={`font-bold mb-4 ${isLabs ? 'text-gray-900' : 'text-white'}`}>{t('footer.legal')}</h4>
            <ul className="space-y-2">
              <li><a href="#" className={`text-sm ${isLabs ? 'text-gray-600' : 'text-gray-400'}`}>{t('footer.legal_notice')}</a></li>
              <li><a href="#" className={`text-sm ${isLabs ? 'text-gray-600' : 'text-gray-400'}`}>{t('footer.cgv')}</a></li>
              <li><a href="#" className={`text-sm ${isLabs ? 'text-gray-600' : 'text-gray-400'}`}>{t('footer.privacy')}</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className={`font-bold mb-4 ${isLabs ? 'text-gray-900' : 'text-white'}`}>{t('footer.contact')}</h4>
            <ul className="space-y-3">
              <li className={`flex items-center gap-2 text-sm ${isLabs ? 'text-gray-600' : 'text-gray-400'}`}>
                <Mail className="w-4 h-4" /> contact@labsagency.fr
              </li>
              <li className={`flex items-center gap-2 text-sm ${isLabs ? 'text-gray-600' : 'text-gray-400'}`}>
                <MapPin className="w-4 h-4" /> Paris, France
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className={`pt-8 border-t ${isLabs ? 'border-gray-200' : 'border-white/5'} flex flex-col sm:flex-row items-center justify-between gap-4`}>
          <p className={`text-sm ${isLabs ? 'text-gray-500' : 'text-gray-500'}`}>
            © 2026 Labs Agency. {t('footer.rights')}
          </p>
          <img 
            src="/labs-logo.png"
            alt="Labs Agency"
            className="h-14"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
